/**
 * Spacing tokens for the design system
 * Standardized spacing scale for consistent layout
 */

export const spacing = {
  // Base spacing scale (in rem, 1rem = 16px)
  0: '0',
  1: '0.25rem', // 4px
  2: '0.5rem', // 8px
  3: '0.75rem', // 12px
  4: '1rem', // 16px
  5: '1.25rem', // 20px
  6: '1.5rem', // 24px
  8: '2rem', // 32px
  10: '2.5rem', // 40px
  12: '3rem', // 48px
  16: '4rem', // 64px
  20: '5rem', // 80px
  24: '6rem', // 96px
  32: '8rem', // 128px
  40: '10rem', // 160px
  48: '12rem', // 192px
  64: '16rem', // 256px
  // Semantic spacing names
  tight: '0.5rem', // 8px
  normal: '1rem', // 16px
  loose: '2rem', // 32px
  // Component-specific spacing
  component: {
    padding: {
      xs: '0.5rem', // 8px
      sm: '0.75rem', // 12px
      md: '1rem', // 16px
      lg: '1.5rem', // 24px
      xl: '2rem', // 32px
    },
    gap: {
      xs: '0.5rem', // 8px
      sm: '0.75rem', // 12px
      md: '1rem', // 16px
      lg: '1.5rem', // 24px
      xl: '2rem', // 32px
    },
  },
} as const;

export type Spacing = typeof spacing;
